import styled from '@emotion/styled';

import { MEDIA_QUERY, COLORS, FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';

import LinkV2 from '@zola/zola-ui/src/components/LinkV2/LinkV2';

export const Banner = styled.div`
  padding: 14px ${SPACING.MD};
  border: 1px solid ${COLORS.ALTO};
  background-color: ${COLORS.WHITE};
  border-radius: 4px;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 645px;
  margin: 0 0 32px auto;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    max-width: 100%;
    margin: 30px 0;
  }
`;

export const Text = styled.p`
  margin: 0 auto 0 0;
  color: ${COLORS.BLACK};
  max-width: 450px;
  padding-right: ${SPACING.MD};
  font-size: ${FONT.FONT_SIZE_SMALL};
  line-height: ${FONT.FONT_SIZE_LARGE};

  ${MEDIA_QUERY.TABLET} {
    max-width: 80%;
  }
`;

export const StyledLink = styled(LinkV2)`
  display: inline-flex;
  flex-flow: row;
  align-items: center;
  font-size: ${FONT.FONT_SIZE_SMALL};
  line-height: ${FONT.FONT_SIZE_SMALL};

  svg {
    display: inline-block;
    margin-left: 6px;
  }
`;
